import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  user?: boolean;
}

/**
 * If we have a logged-in user, display the component, otherwise redirect to login page.
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, user, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      user
        ? <Component user={user} {...props} />
        : <Redirect to={{ pathname: '/' }} />
    }
  />
);

export default PrivateRoute;
